<template>
    <div>
        <apexchart type="line" height="200" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment';

export default {
    computed:{
        ...mapState('graphs', ['marketChangeSeriesData']),
        series: {
            get: function(){
                let data = []

                if (this.marketChangeSeriesData){
                    data = [
                        {
                            name: "Market Change",
                            data: this.marketChangeSeriesData.changes
                        }
                    ]
                }

                return data
            }
        },
        chartOptions: function(){
            return {
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 2000,
                    animateGradually: {
                        enabled: true,
                        delay: 100,
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 100,
                    },
                },
                chart: {
                    fontFamily: 'Lato, sans-serif',
                    selection: {
                        enabled: true,
                        type: 'x',
                        fill: {
                            color: '#41B749',
                            opacity: 0.1
                        },
                        stroke: {
                            width: 1,
                            dashArray: 1,
                            color: '#41B749',
                            opacity: 0.4
                        }
                    },
                    toolbar: {
                        show: true,
                        tools: {
                            download: true,
                            selection: false,
                            zoom: false,
                            zoomin: false,
                            zoomout: false,
                            pan: false,
                            reset: false
                        },
                        autoSelected: 'zoom'
                    },
                    width: '100%'
                },
                colors: ['#41B749', '#000000', '#8581E0'],
                dataLabels: {
                    enabled: false,
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                },
                markers: {
                    size: 0
                },
                noData: {
                    text: "No Data for that criteria",
                    align: "center",
                    verticalAlign: "middle"
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },
                tooltip: {
                    x: {
                        format: 'HH:mm'
                    }
                },
                xaxis: {
                    axisBorder: {
                        show: true,
                        color: '#EAEAEA'
                    },
                    labels: {
                        offsetX: -2,
                        dateTimeFormatter:{
                            hour: 'H'
                        }
                    },
                    type: 'datetime',
                    tooltip: {
                        enabled: false
                    },
                    categories: this.marketChangeSeriesData.times
                },
                yaxis: {
                    min: -Math.max(Math.abs(Math.min(...this.marketChangeSeriesData.changes)), Math.abs(Math.max(...this.marketChangeSeriesData.changes))) - 0.1,
                    max: Math.max(Math.abs(Math.min(...this.marketChangeSeriesData.changes)), Math.abs(Math.max(...this.marketChangeSeriesData.changes))) + 0.1,
                    axisBorder: {
                        show: true,
                        color: '#EAEAEA'
                    }
                }
            }
        },
    },
    watch: {
        chartOptions(){}
    }
}
</script>

<style lang="scss" scoped>

</style>